export const APPLICATION_CREATE_RESET = 'APPLICATION_CREATE_RESET'
export const APPLICATION_CREATE_SET_CREATED = 'APPLICATION_CREATE_SET_CREATED'
export const APPLICATION_CREATE_SET_ERROR = 'APPLICATION_CREATE_SET_ERROR'
export const APPLICATION_CREATE_SET_VIOLATIONS = 'APPLICATION_CREATE_SET_VIOLATIONS'
export const APPLICATION_CREATE_TOGGLE_LOADING = 'APPLICATION_CREATE_TOGGLE_LOADING'
